import {
  ADD_EVENT_INFO_SUCCESS,
  GET_EVENT_INFO,
  GET_EVENT_INFO_FAILED,
  GET_EVENT_INFO_LIST_SUCCESS,
  GET_EVENT_INFO_SUCCESS,
  GET_RSVP_BOOKED_SPOTS_SUCCESS,
  GET_RSVP_WEBPAGE_CONFIG_SUCCESS,
  RESET_EVENT_INFO,
  RESET_EVENT_INFO_LIST,
} from "./actionTypes"

const INIT_STATE = {
  eventInfo: null,
  rsvpBookedSpots: 0,
  rsvpWebpageConfigs: null,
  eventInfoList: [],
  loading: false,
}

const EventInfo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENT_INFO:
      return {
        ...state,
        loading: true,
      }
    case ADD_EVENT_INFO_SUCCESS:
      return {
        ...state,
        eventInfo: action.payload,
      }
    case GET_EVENT_INFO_SUCCESS:
      return {
        ...state,
        eventInfo: action.payload,
        loading: false,
      }
    case GET_EVENT_INFO_FAILED:
      return {
        ...state,
        loading: false,
      }
    case RESET_EVENT_INFO:
      return {
        ...state,
        eventInfo: null,
        rsvpBookedSpots: 0,
        rsvpWebpageConfigs: null,
      }
    case GET_RSVP_BOOKED_SPOTS_SUCCESS:
      return {
        ...state,
        rsvpBookedSpots: action.payload,
      }
    case GET_RSVP_WEBPAGE_CONFIG_SUCCESS:
      return {
        ...state,
        rsvpWebpageConfigs: action.payload,
      }
    case GET_EVENT_INFO_LIST_SUCCESS:
      return {
        ...state,
        eventInfoList: action.payload,
      }
    case RESET_EVENT_INFO_LIST:
      return {
        ...state,
        eventInfoList: [],
      }
    default:
      return state
  }
}

export default EventInfo
